export default class DbUtility {
	constructor(databaseName, version) {
		this.db = null
		this.dbTransaction = null
		this.dbStore = null
		this.databaseName = databaseName
		this.version = version || 1
	}
	/**
	 *打开数据库
	 *
	 * @param {*} [{ deleteWhenUpgradeneed = string []}={}]
	 * @returns
	 * @memberof DbUtility
	 */
	async open({ deleteWhenUpgradeneed } = {}) {
		return new Promise((resolve, reject) => {
			const request = indexedDB.open(this.databaseName, this.version)
			request.onsuccess = (e) => {
				this.db = e.target.result
				this.dbTransaction = null
				resolve(this)
			}
			request.onerror = reject
			request.onupgradeneeded = (e) => {
				this.db = e.target.result
				this.dbTransaction = e.target.transaction
				if (Array.isArray(deleteWhenUpgradeneed) && deleteWhenUpgradeneed.length > 0) {
					deleteWhenUpgradeneed.forEach((store) => {
						if (this.db.objectStoreNames.contains(store)) {
							this.db.deleteObjectStore(store)
						}
					})
					resolve(this)
				} else {
					resolve(this)
				}
			}
		})
	}
	/**
	 *批量添加数据
	 *
	 * @param {*} data
	 * @returns
	 * @memberof DbUtility
	 */
	async addAll(data) {
		if (Array.isArray(data) && data.length > 0) {
			const store = this.db.transaction([this.dbStore], 'readwrite').objectStore(this.dbStore)
			const dataGroup = []
			data.forEach((item) => {
				dataGroup.push(this.add(item, store))
			})
			await Promise.all(dataGroup)
		}
		return this
	}
	/**
	 *添加数据
	 *
	 * @param {*} data
	 * @param {*} store
	 * @returns
	 * @memberof DbUtility
	 */
	async add(data, store) {
		return new Promise((resolve, reject) => {
			if (!(this.dbStore && data)) {
				return reject(new Error('parameters is invalid'))
			}
			if (!store) {
				store = this.db.transaction([this.dbStore], 'readwrite').objectStore(this.dbStore)
			}
			const request = store.put(data)
			request.onsuccess = resolve
			request.onerror = reject
		})
	}
	/**
	 *获取全部,传入filter使用游标查找，key根据主键或索引搜索
	 *
	 * @param {*} [{ filter:function, key:string, index:string|number, range }={}]
	 * @returns
	 * @memberof DbUtility
	 */
	async get({ filter, key, index, range, multi = false } = {}) {
		if (!this.dbStore || !(filter || key)) {
			throw Error('parameters is invalid')
		}
		let store = this.db.transaction([this.dbStore]).objectStore(this.dbStore)
		if (index) {
			store = store.index(index)
		}
		if (typeof filter === 'function') {
			return this.searchByCursor(store, filter, multi)
		} else if (key) {
			return this.searchByKey(store, key, multi)
		}
		return []
	}
	searchByCursor(store, filter, multi) {
		return new Promise((resolve, reject) => {
			const res = []
			const request = store.openCursor()
			request.onsuccess = (e) => {
				const cursor = e.target.result
				if (cursor || (!multi && res.length)) {
					if (filter(cursor.value)) {
						res.push(cursor.value)
					}
					cursor.continue()
				} else {
					resolve(res || [])
				}
			}
			request.onerror = reject
		})
	}
	searchByKey(store, key, multi) {
		return new Promise((resolve, reject) => {
			let request
			if (multi) {
				request = store.getAll(key)
			} else {
				request = store.get(key)
			}
			request.onsuccess = (e) => resolve(e.target.result)
			request.onerror = reject
		})
	}
	/**
     *打开store，没有则创建
     *
     * @param {*} store
     * @param {*} [{ keyPath, index = [] }={}]
     * @returns
     * @memberof DbUtility
     */
    createStore(store, { keyPath, index = [] } = {}) {
		return new Promise((resolve, reject) => {
			if (!this.db.objectStoreNames.contains(store)) {
				let option = {}
				if (keyPath) option.keyPath = keyPath
				else option.autoIncrement = true
				const storeObject = this.db.createObjectStore(store, option)
				index.forEach(({ name, unique }) => {
					storeObject.createIndex(name, name, { unique })
				})
			}
			this.dbStore = store
			if (this.dbTransaction) {
				this.dbTransaction.oncomplete = () => resolve(this)
			} else {
				resolve(this)
			}
		})
	}
}
